export default {
  title: 'Nahrajte své bankovní výpisy',
  // tooltip: 'Propojením Vaší banky nebo nahráním výpisu nám umožníte ověřit si Vaší bonitu a tím Vám budeme moci nabídnout co nejvýhodnější půjčku.',
  tooltip: {
    first: 'Nahráním výpisu nám umožníte ověřit si Vaší bonitu a tím Vám budeme moci nabídnout co nejvýhodnější půjčku.',
    second: 'Výpisy musí být minimálně za posledních 90 dní.',
  },
  authDialog: {
    title: 'Rychle načíst z bankovního účtu',
    connctedTitle: 'Rychle načíst z jiného bankovního účtu',
    shortTitle: 'Napojit bankovní účet',
    close: 'Zavřít',
  },
  accounts: 'Napojené účty:',
};
